var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGrey4Inline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91,
  height: 75,
  viewBox: "0 0 91 75",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#242424",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.4 22.3 6.5 5.6v54l28.9 8.7v-46Zm3.1.1v45.9l29.1-8.8V5.6L38.5 22.4ZM90.2 4.3c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4V8h6.8V4.3Zm-5.9 54.3h-.9l3.4 11.9 3.4-11.9h-.8.8v-48h-6.8v48h.9Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.8 8-3.1-2.5V61L38.6 71.4h-3.2l-32-8.9v-57L.3 8v56.6l34.9 9.7h3.6l32.1-10.2 2.9-.9z"
}))));
export default SvgGrey4Inline;